import { AxiosResponse } from "axios";

import { API } from "../index";


export interface PublicSeatLayoutPackage {
  id: number;
  name: string;
  color: string;
  display_order: number;
}

export interface PublicSeatLayoutSeatAvailability {
  status: string;
  can_select: boolean;
  reason: string;
  is_able: boolean;
}

export interface PublicSeatLayoutSeat {
  id: number;
  spot_id: number;
  spot_name: string;
  layout_package: number | null;
  label: string;
  seat_type: string;
  x: number;
  y: number;
  width: number;
  height: number;
  rotation: number;
  display_order: number;
  is_active: boolean;
  meta: Record<string, any> | null;
  availability: PublicSeatLayoutSeatAvailability;
}

export interface PublicSeatLayout {
  id: number;
  name: string;
  reservation_package: number;
  reservation_package_name: string;
  canvas_width: number;
  canvas_height: number;
  background_image_url: string;
  status: string;
  version: number;
  published_at: string | null;
  packages: PublicSeatLayoutPackage[];
  seats: PublicSeatLayoutSeat[];
}

export interface SeatLayoutReserveCheckResponse {
  valid: boolean;
  invalid_spot_ids: number[];
  seats: PublicSeatLayoutSeat[];
}


export const seatLayoutService = {
  getPublishedByPackage: (
    packageId: number | string,
    params: { date?: string; start_date?: string; end_date?: string },
  ): Promise<AxiosResponse<PublicSeatLayout>> =>
    API.get(`/api/v2/public/seat-layouts/by-package/${packageId}/`, { params }),

  getAvailability: (
    layoutId: number | string,
    params: { date?: string; start_date?: string; end_date?: string },
  ): Promise<AxiosResponse<PublicSeatLayout>> =>
    API.get(`/api/v2/public/seat-layouts/${layoutId}/availability/`, { params }),

  reserveCheck: (
    layoutId: number | string,
    payload: { date?: string; start_date?: string; end_date?: string; spot_ids: number[] },
  ): Promise<AxiosResponse<SeatLayoutReserveCheckResponse>> =>
    API.post(`/api/v2/public/seat-layouts/${layoutId}/reserve-check/`, payload),
};
